export default {
  'menu.IotHardwareListPage': '设备管理列表',
}